<template>
	<CList :pConfigList="ConfigList" :segurity="segurity">
		<template slot="bodyForm">
			<CLoader :pConfigLoad="ConfigLoad">
				<template slot="BodyFormLoad">
					<div class="container-fluid">
						<form id="FormNotaPago" role="form" method="post" autocomplete="off" onSubmit="return false">

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
									<label class="form-label" for="NombreReceptor">Cliente</label>
									<div class="input-group">
										<input type="text" v-model="objNotaPago.NombreReceptor" class="form-control" id="NombreReceptor" placeholder="Ingresar Nombre del Receptor" readonly />
										<button type="button" @click="AbrirModalClientes()" class="btn btn-outline-primary boder-extend" id="button-addon2" :disabled="(objNotaPago.IdNotaPago>0)">
											<i class="fa fa-search"></i>
										</button>
									</div>
									<CValidation v-if="this.errorvalidacion.IdCliente" :Mensaje="'*'+errorvalidacion.IdCliente[0]"/>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
									<label class="form-label" for="RFCreceptor">RFC</label>
									<input type="text" v-model="objNotaPago.RFCreceptor" class="form-control" id="RFCreceptor" placeholder="Ingresar RFC Receptor" readonly/>
									<CValidation v-if="this.errorvalidacion.RFCreceptor" :Mensaje="'*'+errorvalidacion.RFCreceptor[0]"/>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
									<label class="form-label" for="CPReceptor">Código Postal</label>
									<input type="text" v-model="objNotaPago.CPReceptor" class="form-control" id="CPReceptor" placeholder="Ingresar CP Receptor" readonly/>
									<CValidation v-if="this.errorvalidacion.CPReceptor" :Mensaje="'*'+errorvalidacion.CPReceptor[0]"/>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
									<label class="form-label" for="Folio">Folio</label>
									<input type="text" v-model="objNotaPago.Folio" class="form-control" id="Folio" placeholder="Folio Complemento" readonly/>
									<CValidation v-if="this.errorvalidacion.Folio" :Mensaje="'*'+errorvalidacion.Folio[0]"/>
								</div>
							</div>
							
							
							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="FormaPago">Forma de Pago</label>
									<select v-model="objNotaPago.FormaPago" class="form-control form-select" id="FormaPago">
										<option value="">Seleccione una opción</option>
										<option v-for="(item,index) in ListaFormaPago" :key="index" :value="item.Clave+'~'+item.Nombre">
											{{item.Clave+' - '+item.Nombre}}
										</option>
									</select>
									<CValidation v-if="this.errorvalidacion.FormaPago" :Mensaje="'*'+errorvalidacion.FormaPago[0]"/>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="Moneda">Moneda</label>
									<select v-model="objNotaPago.Moneda" class="form-control form-select" id="Moneda">
										<option value="">Seleccione una opción</option>
										<option v-for="(item,index) in ListaMonedas" :key="index" :value="item.Clave">
											{{item.Clave+' - '+item.Nombre}}
										</option>
									</select>
									<CValidation v-if="this.errorvalidacion.Moneda" :Mensaje="'*'+errorvalidacion.Moneda[0]"/>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="TipoCambio">Tipo de Cambio</label>
									<input type="text" v-model="objNotaPago.TipoCambio" @input="$number_decimal($event,objNotaPago,'TipoCambio');" class="form-control" id="TipoCambio" placeholder="Ingresar Tipo de Cambio" />
									<CValidation v-if="this.errorvalidacion.TipoCambio" :Mensaje="'*'+errorvalidacion.TipoCambio[0]"/>
								</div>
							</div>

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="RfcEmisorCtaOrd">RFC Emisor Cta. Ord</label>
									<input type="text" v-model="objNotaPago.RfcEmisorCtaOrd" class="form-control" id="RfcEmisorCtaOrd" placeholder="Ingresar Rfc Emisor CtaOrd" />
									<CValidation v-if="this.errorvalidacion.RfcEmisorCtaOrd" :Mensaje="'*'+errorvalidacion.RfcEmisorCtaOrd[0]"/>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="RfcEmisorCtaBen">RFC Emisor Cta. Ben</label>
									<input type="text" v-model="objNotaPago.RfcEmisorCtaBen" class="form-control" id="RfcEmisorCtaBen" placeholder="Ingresar Rfc Emisor CtaBen" />
									<CValidation v-if="this.errorvalidacion.RfcEmisorCtaBen" :Mensaje="'*'+errorvalidacion.RfcEmisorCtaBen[0]"/>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="CtaOrdenante">Cta. Ordenante</label>
									<input type="text" v-model="objNotaPago.CtaOrdenante" class="form-control" id="CtaOrdenante" placeholder="Ingresar Cuenta Ordenante" />
									<CValidation v-if="this.errorvalidacion.CtaOrdenante" :Mensaje="'*'+errorvalidacion.CtaOrdenante[0]"/>
								</div>
							</div>
							
							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="CtaBeneficiario">Cta. Beneficiario</label>
									<input type="text" v-model="objNotaPago.CtaBeneficiario" class="form-control" id="CtaBeneficiario" placeholder="Ingresar Cuenta Beneficiario" />
									<CValidation v-if="this.errorvalidacion.CtaBeneficiario" :Mensaje="'*'+errorvalidacion.CtaBeneficiario[0]"/>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="NumOperacion">N° de Operación</label>
									<input type="text" v-model="objNotaPago.NumOperacion" class="form-control" id="NumOperacion" placeholder="Ingresar Número de Operación" />
									<CValidation v-if="this.errorvalidacion.NumOperacion" :Mensaje="'*'+errorvalidacion.NumOperacion[0]"/>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="Monto">Monto</label>
									<input type="text" v-model="objNotaPago.Monto" class="form-control" id="Monto" placeholder="Ingresar Monto" readonly />
									<CValidation v-if="this.errorvalidacion.Monto" :Mensaje="'*'+errorvalidacion.Monto[0]"/>
								</div>
							</div>

							<hr class="horizontal dark">

							<div class="row">
								<div class="col-6 col-sm-6 col-md-6 col-lg-6">
									<p class="text-uppercase text-sm">Documentos Relacionados</p>
								</div>
							</div>

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="TipoRelacion">Tipo Relación</label>
									<select v-model="objNotaPago.TipoRelacion" @change="BorrarUUID()" class="form-control form-select" id="TipoRelacion">
										<option value="">Seleccione una opción</option>
										<option v-for="(item,index) in ListaTipoRelacion" :key="index" :value="item.Clave+'~'+item.Nombre">
											{{item.Clave+' - '+item.Nombre}}
										</option>
									</select>
									<CValidation v-if="this.errorvalidacion.TipoRelacion" :Mensaje="'*'+errorvalidacion.TipoRelacion[0]"/>
								</div>
								
								<div v-show="objNotaPago.TipoRelacion!=''" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="IdDocumentoRelacionado">UUID</label>
									<input type="text" v-model="objNotaPago.IdDocumentoRelacionado" class="form-control" id="IdDocumentoRelacionado" placeholder="Ingresar UUID" :readonly="objNotaPago.IdCliente==0" />
									<CValidation v-if="this.errorvalidacion.IdDocumentoRelacionado" :Mensaje="'*'+errorvalidacion.IdDocumentoRelacionado[0]"/>
								</div>

								<div v-show="objNotaPago.TipoRelacion!=''" class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
									<!-- <div class="row">
										<div class="col-12">
											<label style="opacity:0">sdsd</label>
										</div>
									</div> -->
									<button class="btn btn-sm btn-secondary" @click="AbrirModalRelacionadas()" v-b-tooltip.hover.Top title="Buscar Facturas" style="margin-top:32px;" :disabled="objNotaPago.IdCliente==0">
										<i class="fa fa-file"></i>
									</button>
								</div>
							</div>

							<div class="row mt-4">
								<div class="col-6 col-sm-6 col-md-2 col-lg-2">
									<p class="text-uppercase text-sm">Pagos</p>
								</div>
								<div class="col-6 col-sm-6 col-md-5 col-lg-5">
									<hr class="horizontal dark">
								</div>

								<div class="col-6 col-sm-6 col-md-3 col-lg-3">
									<div class="row">
										<div class="col-6 col-sm-6 col-md-4 col-lg-4">
											<label class="form-label" for="FechaPago">Fecha Pago</label>
										</div>
										<div class="col-6 col-sm-6 col-md-8 col-lg-8">
											<div class="calendar">
												<Datepicker v-model="objNotaPago.FechaPago" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" :disabled-dates="Setpicker.DisabledDates" placeholder="0000-00-00"></Datepicker>
											</div>
											<CValidation v-if="this.errorvalidacion.FechaPago" :Mensaje="'*'+errorvalidacion.FechaPago[0]"/>
										</div>
									</div>									
								</div>

								<div class="col-6 col-sm-6 col-md-6 col-lg-2 col-xl-2 text-end">
									<button type="button" @click="AbrirModalFacturas()" class="btn btn-sm btn-primary" :disabled="objNotaPago.IdCliente == 0">
										<i class="fa fa-plus"></i> Facturas
									</button>
								</div>
							</div>

							<div class="row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
								<CLoader :pConfigLoad="ConfigLoadTable">
								<template slot="BodyFormLoad">
									<div class="table-responsive pb-0">
										<table class="table table-striped mb-0">
											<thead>
												<tr>
													<th width="11%">Factura</th>
													<th width="3%">MonedaDR</th>
													<th width="9%">Tipo CambioDR</th>
													<th width="15%">Objeto Imp</th>
													<th width="17%">Método de Pago DR</th>
													<th width="5%">Parcialidad</th>
													<th width="14%"></th>
													<th width="23%">
														<label style="color: transparent;">Importes</label>
													</th>
													<th width="3%">*</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(item,index) in ListaConceptosNota" :key="index">
													<td>
														{{(index+1)+' - '+item.Folio}}
													</td>
													<td>
														<input type="text" v-model="item.MonedaDR" class="form-control form-control-sm" readonly>
													</td>
													<td>
														<input type="text" v-model="item.TipoCambioDR" @input="$number_decimal($event,item,'TipoCambioDR');EjecutarCalculos()" class="form-control form-control-sm" :readonly="(item.Bloqueo == 1)?true:false">
													</td>
													<td>
														<select v-model="item.ClaveObjImpuestoDR" class="form-control form-select">
															<option value="">Seleccione</option>
															<option v-for="(item2,index2) in ListaObjetoImp" :key="index2" :value="item2.Clave">
																{{item2.Clave+' - '+item2.Nombre}}
															</option>
														</select>
													</td>
													<td style="text-wrap:wrap;">
														
														{{CambiarPalabra(item.MetodoDePagoDR)}}
														
													</td>
													<td>
														<input type="text" v-model="item.NumParcialidad" @input="$onlyNums($event,item,'NumParcialidad')" class="form-control form-control-sm" >
													</td>
													<td>
														<div class="row">
															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 py-1">
																<span>Imp. Saldo Ant.</span>
															</div>
															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 py-1">
																<span>Importe Pagado</span>
															</div>
															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 py-1">
																<span>Imp. Saldo Ins.</span>
															</div>
														</div>
													</td>
													<td>
														<div class="row">
															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
																<input type="text" v-model="item.ImpSaldoAnterior" class="form-control form-control-sm" readonly>
															</div>
															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
																<input type="text" v-model="item.ImpPagado" @input="$number_decimal($event,item,'ImpPagado');EjecutarCalculos()" class="form-control form-control-sm" >
															</div>
															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
																<input type="text" v-model="item.ImpSaldoInsoluto" class="form-control form-control-sm" readonly>
															</div>
														</div>
														
													</td>
													<td>
														<button v-if="item.IdDetallePago==0" type="button" @click="EliminarItemConcepto(index)" class="btn btn-danger btnpequenio">
															<i class="fa fa-trash"></i>
														</button>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
									<CValidation v-if="this.errorvalidacion.ArregloEventos" :Mensaje="'*'+errorvalidacion.ArregloEventos[0]"/>
								</template>
								</CLoader>
								</div>
							</div>

								
							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<label class="form-label" for="Observaciones">Observaciones</label>
									<textarea v-model="objNotaPago.Observaciones" class="form-control" id="Observaciones" placeholder="Ingresar Observaciones" rows="3"></textarea>
									<CValidation v-if="this.errorvalidacion.Observaciones" :Mensaje="'*'+errorvalidacion.Observaciones[0]"/>
								</div>
							</div>

							<div class="row justify-content-end mt-4 mb-4">
								<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 text-end mt-2">
									<span :class="['badge', (NumeroTimbres>0)?'bg-primary':'bg-danger']">Timbres Disponibles: {{NumeroTimbres}}</span>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
									<select v-model="objAgenos.Guardar" class="form-contorl form-select">
										<option value="1">Guardar</option>
										<template v-if="objNotaPago.Facturado =='NO'">
											<template v-if="(NumeroTimbres>0)">
												<option value="2">Guardar y Facturar</option>
											</template>
										</template>
									</select>
								</div>
							</div>
							
													
							<br>
							<CBtnSave :poBtnSave="oBtnSave" />
						</form>

						<CModal :pConfigModal="ConfigModal1" :poBtnSave="oBtnSave1">
							<template slot="Form">
								<ListClientes :poBtnSave="oBtnSave1"></ListClientes>
							</template>
						</CModal>

						<CModal :pConfigModal="ConfigModal2" :poBtnSave="oBtnSave2">
							<template slot="Form">
								<ListRelacionados :poBtnSave="oBtnSave2"></ListRelacionados>
							</template>
						</CModal>

						<CModal :pConfigModal="ConfigModal3" :poBtnSave="oBtnSave3">
							<template slot="Form">
								<ListFacturas :poBtnSave="oBtnSave3"></ListFacturas>
							</template>
						</CModal>
					</div>
				</template>
			</CLoader>
		</template>
	</CList>
	
</template>
<script>
import moment from 'moment';
import Calendar from '@/helpers/StaticComboBox.js';

import ListClientes from '@/views/modulos/finanzas/notaPago/ListClientes.vue';
import ListRelacionados from '@/views/modulos/finanzas/notaPago/ListRelacionados.vue';
import ListFacturas from '@/views/modulos/finanzas/notaPago/ListFacturas.vue';

const EmitEjecuta = 'seccionNotaPago';
const EmitEjecuta1 = 'seccionClientes';
const EmitEjecuta2 = 'seccionRelacion';
const EmitEjecuta3 = 'seccionFactura';


export default {
    name: 'FormNotaPago',
    props: ['Id'],
    components:{
		ListClientes,
		ListRelacionados,
		ListFacturas,
    },
    data() {
        return {
			ConfigList:{
                Title: 'Formulario Nota de Pago',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
				ShowTitleFirst: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
			oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'notapago',
                EmitSeccion: EmitEjecuta,
            },
			ConfigLoadTable:{
                ShowLoader: false,
                ClassLoad: false,
            },
			ConfigModal1:{
                ModalTitle: "Listado de Hoteles/Empresas",
                ModalNameId: 'ModalForm2',
                EmitSeccion: EmitEjecuta1,
                ModalSize: 'xl',
				ShowFooter: false,
            },
            oBtnSave1: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta1,
            },
			ConfigModal2:{
                ModalTitle: "Facturas Relacionadas",
                ModalNameId: 'ModalForm3',
                EmitSeccion: EmitEjecuta2,
                ModalSize: 'lg',
				ShowFooter: false,
            },
            oBtnSave2: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
            },
			ConfigModal3:{
                ModalTitle: "Facturas",
                ModalNameId: 'ModalForm4',
                EmitSeccion: EmitEjecuta3,
                ModalSize: 'xl',
				ShowFooter: false,
            },
            oBtnSave3: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta3,
            },
            objNotaPago: {
				IdNotaPago: 0,
				IdUsuario: 0,
				FechaRegistro: '',
				Folio: '',
				Serie: '',
				TipoComprobante: 'P',
				FormaPago: '',
				ClavePago: '',
				Monto: '',
				NumOperacion: '',
				RfcEmisorCtaOrd: '',
				Banco: '',
				CtaOrdenante: '',
				RfcEmisorCtaBen: '',
				CtaBeneficiario: '',
				UsoCfdi: '',
				Moneda: '',
				TipoCambio: '',
				Facturado: 'NO',
				Observaciones: '',
				RFCemisor: '',
				NombreEmisor: '',
				RegimenFiscal: '',
				CPEmisor: '',
				IdCliente: 0,
				RFCreceptor: '',
				NombreReceptor: '',
				CPReceptor: '',
				FechaPago: '',
				EstatusCancel: '',
				RegimenFiscalCliente: '',
				VersionFact: '',
				TipoRelacion: '',
				IdDocumentoRelacionado: '',
				IdEmpresa: 0,
				IdSucursal: 0,
				
            },
            segurity: {},
            errorvalidacion: [],
			Emit: EmitEjecuta,
			ListaFormaPago: [],
			ListaMonedas: [],
			ListaTipoRelacion: [],
			ListaObjetoImp: [],
			ListaConceptosNota: [],
			objAgenos: {
				Guardar: 1,
			},
			Setpicker: Calendar.calendarSettings,
			NumeroTimbres: 0,
        }
    },
    methods :
    {
       	async Guardar()
        {
			let band1 = 0;
            let msg1 = '';

			if(this.ListaConceptosNota.length == 0)
			{
				this.$toast.warning('Debe agregar al menos una factura.')
				return false;
			}

			$.each(this.ListaConceptosNota, function(key, value){
                if(value.MonedaDR != 'MXN' && value.TipoCambioDR == ''){
                    msg1 = "El campo Tipo de cambio DR de la partida: "+(key+1)+" no puede estar vacio";
                    band1++;
                    return false;
                }
                else if(value.ClaveObjImpuestoDR == ''){
                    msg1 = "El campo Objeto de Impuesto de la partida: "+(key+1)+" no puede estar vacio";
                    band1++;
                    return false;
                }
                else if(value.NumParcialidad == ''){
                    msg1 = "El campo Número de parcialidad de la partida: "+(key+1)+" no puede estar vacio";
                    band1++;
                    return false;
                }
				else if(value.ImpPagado == ''){
                    msg1 = "El campo Importe Pagado de la partida: "+(key+1)+" no puede estar vacio";
                    band1++;
                    return false;
                }
            });
            if(band1>0){ this.$toast.warning(msg1); return false; }
			

			let formData = new FormData();
			formData.set('IdNotaPago', this.objNotaPago.IdNotaPago);
			formData.set('IdUsuario', this.objNotaPago.IdUsuario);
			formData.set('FechaRegistro', this.objNotaPago.FechaRegistro);
			formData.set('Folio', this.objNotaPago.Folio);
			formData.set('Serie', this.objNotaPago.Serie);
			formData.set('TipoComprobante', this.objNotaPago.TipoComprobante);

			let ClavePago = '';
			let FormaPago = '';

			if(this.objNotaPago.FormaPago!='')
			{
				let separe = this.objNotaPago.FormaPago.split('~');
				ClavePago = separe[0];
				FormaPago = separe[1];
			}

			if(this.objNotaPago.FechaPago!=''){
				this.objNotaPago.FechaPago = moment(this.objNotaPago.FechaPago).format('YYYY-MM-DD');
			}

			formData.set('FormaPago',FormaPago);
			formData.set('ClavePago',ClavePago);

			formData.set('Banco', this.objNotaPago.Banco);
			formData.set('TipoCambio', this.objNotaPago.TipoCambio);
			formData.set('Moneda', this.objNotaPago.Moneda);
			formData.set('Monto', this.objNotaPago.Monto);

			formData.set('CtaOrdenante', this.objNotaPago.CtaOrdenante);
			formData.set('NumOperacion', this.objNotaPago.NumOperacion);
			formData.set('RfcEmisorCtaOrd', this.objNotaPago.RfcEmisorCtaOrd);
			formData.set('RfcEmisorCtaBen', this.objNotaPago.RfcEmisorCtaBen);
			formData.set('CtaBeneficiario', this.objNotaPago.CtaBeneficiario);

			formData.set('Facturado', this.objNotaPago.Facturado);
			formData.set('UsoCfdi', this.objNotaPago.UsoCfdi);
			formData.set('Observaciones', this.objNotaPago.Observaciones);

			formData.set('RFCemisor', this.objNotaPago.RFCemisor);
			formData.set('NombreEmisor', this.objNotaPago.NombreEmisor);
			formData.set('RegimenFiscal', this.objNotaPago.RegimenFiscal);
			formData.set('CPEmisor', this.objNotaPago.CPEmisor);

			formData.set('IdCliente', this.objNotaPago.IdCliente);
			formData.set('RFCreceptor', this.objNotaPago.RFCreceptor);
			formData.set('NombreReceptor', this.objNotaPago.NombreReceptor);
			formData.set('CPReceptor', this.objNotaPago.CPReceptor);
			formData.set('RegimenFiscalCliente', this.objNotaPago.RegimenFiscalCliente);

			let TipoRelacion = (this.objNotaPago.TipoRelacion =='')?'':this.objNotaPago.TipoRelacion;
			formData.set('FechaPago', this.objNotaPago.FechaPago);
			formData.set('EstatusCancel', this.objNotaPago.EstatusCancel);
			formData.set('VersionFact', this.objNotaPago.VersionFact);
			formData.set('TipoRelacion', TipoRelacion);
			formData.set('IdDocumentoRelacionado', this.objNotaPago.IdDocumentoRelacionado);
			formData.set('IdEmpresa', this.objNotaPago.IdEmpresa);
			formData.set('IdSucursal', this.objNotaPago.IdSucursal);

			formData.set('Guardar', this.objAgenos.Guardar);
			formData.set('Detalle', JSON.stringify(this.ListaConceptosNota));
			
			this.errorvalidacion = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;
			
			await this.$http.post('notasPago', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
			let obj = {
				message: res.data.message,
				typemsg: res.data.typemsg,
			};
			this.EjecutaMensajeAlerta(obj);
        },
        EjecutaConError(err)
        {
			this.oBtnSave.DisableBtn = false;
			// console.log(err.response.data)
			// SI DEVUELVE TYPEMSG CORRESPONDE A UN ERROR DE TIMBRADO, SINO CORRESPONDE A UN ERROR DE VALIDACION NORMAL
			if(err.response.data.typemsg)
			{
				this.bus.$emit('RunAlerts_'+this.Emit,3);
				this.EjecutaMensajeAlerta(err.response.data);
			}
			else
			{
				if(err.response.data.errors){
					this.errorvalidacion = err.response.data.errors;
					this.oBtnSave.Toast = 2;
				}
				else{
					this.$toast.error(err.response.data.message);
				}
			}
        },
		EjecutaMensajeAlerta(DataAlert)
		{
			//console.log(DataAlert);
			let Titulo = 'Se produjo un error al timbrar';
			let Mensaje = DataAlert.message;
			let Icon = 'warning';
			let Content = '';

			switch(DataAlert.typemsg)
			{
				case 3:

					let htmls = `
					<h3>Problemas detectados:</h3><br>
					<hr>
					<div class="card scrollCfdi">
						<div class="card-body">
							<ul class="list-group">`;
					
					$.each(DataAlert.errors.Error, function(key, value){
						htmls+=`<li class="list-group-item">`+value+`</li>`;
					});

					htmls+=`</ul>
						</div>
					</div>`;
					Content = htmls;

				break;

				case 1:
					Titulo = 'Facturado Exitosamente';
					Icon = 'success';
				break;

				case 0:
					Titulo = 'Información Guardada Correctamente';
					Icon = 'success';
				break;
			}

			this.$swal(
            {
                title: '<h2 style="font-size:25px; font-weight: 700;">'+Titulo+'</h2>',
                text: Mensaje,
				html: Content,
                icon: Icon,
                confirmButtonText: 'Aceptar',
                showCloseButton: true,
                showLoaderOnConfirm: true,
                confirmButtonColor: '#00a389',
            });
			this.Regresar();
		},
		Recuperar()
        {
            this.$http.get(
                "notasPago/"+this.objNotaPago.IdNotaPago
            ).then((res) => {
                this.objNotaPago = res.data.data;
				let response = res.data.detalle;

				response.map(function(element){
					if(element.MonedaDR == 'MXN'){
						element.Bloqueo = 1;
					}
					else{
						element.Bloqueo = 0;
					}
				});

				this.ListaConceptosNota = response;

				let Union = this.objNotaPago.ClavePago+'~'+this.objNotaPago.FormaPago;
				this.objNotaPago.FormaPago = Union;
				this.objNotaPago.Folio = this.objNotaPago.Serie+' - '+this.objNotaPago.Folio;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objNotaPago.Fecha.replace(/-/g,'\/');
                this.objNotaPago.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objNotaPago = {
				IdNotaPago: 0,
				IdUsuario: 0,
				FechaRegistro: '',
				Folio: '',
				Serie: '',
				TipoComprobante: 'P',
				FormaPago: '',
				ClavePago: '',
				Monto: '',
				NumOperacion: '',
				RfcEmisorCtaOrd: '',
				Banco: '',
				CtaOrdenante: '',
				RfcEmisorCtaBen: '',
				CtaBeneficiario: '',
				UsoCfdi: '',
				Moneda: '',
				TipoCambio: '',
				Facturado: 'NO',
				Observaciones: '',
				RFCemisor: '',
				NombreEmisor: '',
				RegimenFiscal: '',
				CPEmisor: '',
				IdCliente: 0,
				RFCreceptor: '',
				NombreReceptor: '',
				CPReceptor: '',
				FechaPago: '',
				EstatusCancel: '',
				RegimenFiscalCliente: '',
				VersionFact: '',
				TipoRelacion: '',
				IdDocumentoRelacionado: '',
				IdEmpresa: 0,
				IdSucursal: 0,
				
            }
            this.errorvalidacion = [];
        },
		Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute});
            // this.$router.push({name:'routeraregresar',params:{obj:this.obj}});
        },
		GetListCombosConfig()
		{
			this.$http.get(
                "getCombosfactura"
            ).then((res) => {
				this.ListaFormaPago 	= res.data.FormaPago;
				this.ListaMonedas 		= res.data.Moneda;
				this.ListaTipoRelacion	= res.data.TipoRelacion;
				this.ListaObjetoImp 	= res.data.ObjetoImp;

            }).finally(()=>{
				this.GetTimbresDisponibles();
                this.ConfigLoad.ShowLoader = false;
            });
		},
		AbrirModalClientes()
		{
			let obj = {
				/* IdCliente: this.objFactura.IdCliente,
				RFCcliente: this.objFactura.RfcCliente,
				Agregados: this.ListaDocsRelacionados, */
			}
			this.bus.$emit('NewModal_'+EmitEjecuta1,obj);
		},
		AbrirModalRelacionadas()
		{
			let obj = {
				IdCliente: this.objNotaPago.IdCliente,
				UUID: this.objNotaPago.IdDocumentoRelacionado,
			}
			this.bus.$emit('NewModal_'+EmitEjecuta2,obj);
		},
		AbrirModalFacturas()
		{
			let obj = {
				IdCliente: this.objNotaPago.IdCliente,
				Agregados: this.ListaConceptosNota,
			}
			this.bus.$emit('NewModal_'+EmitEjecuta3,obj);
			
		},
		SetDataCliente(obj)
		{
			this.objNotaPago.IdCliente = obj.IdAgente;
			this.objNotaPago.NombreReceptor = obj.RazonSocial;
			this.objNotaPago.RFCreceptor = obj.Rfc;
			this.objNotaPago.CPReceptor = obj.CP;
			this.objNotaPago.RegimenFiscalCliente = obj.RegimenFiscal;
		},
		SetDataNotaRel(obj){
			this.objNotaPago.IdDocumentoRelacionado = obj.UUID;
		},
		SetDataFactura(obj)
		{
			this.ListaConceptosNota.push(obj)
		},
		BorrarUUID()
		{
			if(this.objNotaPago.TipoRelacion == ''){
				this.objNotaPago.IdDocumentoRelacionado = '';
			}
		},
		CambiarPalabra(word)
		{
			let newWord = '';
			if(word!='' && word!=undefined){
				newWord = word.replace('~',' - ');
			}

			return newWord;
		},
		EliminarItemConcepto(index)
		{
			this.ListaConceptosNota.splice(index, 1);
			this.EjecutarCalculos();
		},
		EjecutarCalculos()
		{
			let Arreglo = this.ListaConceptosNota;
			let Pago = 0;

			for(let i=0; i<Arreglo.length; i++)
            {
				let ImpSaldoAnt = Arreglo[i].ImpSaldoAnterior;
				let ImpPagado = Arreglo[i].ImpPagado;
				let ImpInsoluto = Arreglo[i].ImpSaldoInsoluto;
				let calculo = 0;

				ImpSaldoAnt = (isNaN(ImpSaldoAnt)) ? 0 : parseFloat(ImpSaldoAnt);
				ImpPagado = (isNaN(ImpPagado)) ? 0 : parseFloat(ImpPagado);
				ImpInsoluto = (isNaN(ImpInsoluto)) ? 0 : parseFloat(ImpInsoluto);

				calculo = parseFloat(ImpSaldoAnt-ImpPagado);

				if(calculo<0)
				{
					calculo = 0;
					Arreglo[i].ImpPagado = ImpSaldoAnt;
					//ImpPagado = ImpSaldoAnt;
				}


				calculo = (isNaN(calculo)) ? 0 : parseFloat(calculo);
				Arreglo[i].ImpSaldoInsoluto = calculo.toFixed(2);
				if(ImpPagado != ''){
					Pago+= parseFloat(isNaN(ImpPagado)?0:ImpPagado);
				}
			}

			this.objNotaPago.Monto = Pago.toFixed(2);
		},
		GetTimbresDisponibles()
		{
			this.$http.get(
                "getTimbresfactura"
            ).then((res) => {
				this.NumeroTimbres = res.data.timbres;
			}).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
		},
    },
	created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('AgregarClienteNota');
        this.bus.$off('AgregarFacturasNota');
        this.bus.$off('AgregarNotalRel');
        this.bus.$off('Save_'+this.Emit);
    },
    mounted()
    {
		this.oBtnSave.DisableBtn = false;
        this.Limpiar();
		this.GetListCombosConfig();

        if(this.Id!='') 
        {
            this.objNotaPago.IdNotaPago = this.Id;
            this.Recuperar();
        }
		else
		{
			this.ConfigLoad.ShowLoader = false;
		}

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });

        this.bus.$on('AgregarClienteNota',(obj)=>
        {
            this.SetDataCliente(obj);
        });

        this.bus.$on('AgregarFacturasNota',(obj)=>
        {
            this.SetDataFactura(obj);
        });

        this.bus.$on('AgregarNotalRel',(obj)=>
        {
            this.SetDataNotaRel(obj);
        });
    }
}
</script>
